import BannerAward2024 from '../img/banner/Award2024.png';
import icon1 from '../img/event/icon1.png';
import icon2 from '../img/event/icon2.png';
import icon3 from '../img/event/icon3.png';
import Title from '../img/event/2505/title.png';
import Online_Title from '../img/event/2505/online_session_title.png';
import Online_Video from '../img/event/2505/online_session_video.png';
import React, { ReactNode } from 'react';
import cursor from '../img/event/cursor.svg';
import {
  EmojiChildrenBox,
  EmojiChildrenLeftBox,
  EmojiChildrenRightBox,
} from './common/EmojiChildrenBox';
import flower1 from '../img/event/2505/flower1.png';
import flower2 from '../img/event/2505/flower2.png';
import leaf from '../img/event/2505/leaf.png';
import vector from '../img/event/2505/vector.png';
import balloon1 from '../img/event/2505/balloon1.png';
import balloon2 from '../img/event/2505/balloon2.png';
import balloon3 from '../img/event/2505/balloon3.png';
import balloon4 from '../img/event/2505/balloon4.png';
import risen1 from '../img/event/2505/risen1.png';
import risen2 from '../img/event/2505/risen2.png';
const HomeschoolEvent_25_5 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="relative flex items-center justify-center overflow-hidden bg-[#FFEDE7]">
        {/* 1. 배경 컨테이너 레이어 */}
        <div className="absolute inset-0">
          <img
            src={flower1}
            alt="flower1"
            className="absolute -left-6 top-52 max-w-[100px] select-none sm:-left-8 sm:top-64 sm:max-w-[150px] md:-left-12 md:top-72 md:max-w-[200px]"
          />
          <img
            src={flower2}
            alt="flower2"
            className="absolute left-20 top-0 max-w-16 select-none sm:left-24 sm:max-w-20 md:left-32 md:max-w-24"
          />
          <img
            src={leaf}
            alt="leaf"
            className="absolute -right-3 top-6 max-w-16 select-none sm:-right-4 sm:top-8 sm:max-w-20 md:-right-5 md:top-10 md:max-w-24"
          />
          <img
            src={vector}
            alt="vector"
            className="absolute right-6 top-60 max-w-10 select-none sm:right-10 sm:top-72 sm:max-w-14 md:right-14 md:top-72 md:max-w-16"
          />
        </div>

        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="relative m-auto flex max-w-[720px] flex-col gap-14 px-5 py-20">
          {/* 상단 타이틀 섹션 */}
          <div className="flex flex-col items-center justify-center gap-10 sm:gap-12">
            <section className="flex flex-col items-center justify-center gap-3">
              <div className="text-center text-2xl font-bold text-black sm:text-3xl">
                5월 가정의 달에는
              </div>
              <div className="m-auto flex max-w-[480px] flex-col">
                <img src={Title} alt="영어와 신앙으로" />
              </div>
            </section>

            {/* 말풍선 섹션 */}
            <section className="mx-auto flex w-[95%] min-w-[276px] max-w-[360px] flex-col justify-center gap-3 text-lg font-bold sm:w-full sm:max-w-none sm:gap-5">
              <EmojiChildrenLeftBox
                icon={icon1}
                text="가정의 달, 가정의 힘으로 집에서 시작되는 진짜 제대로 된 교육이 필요하다면?"
                margin="18%"
                bgColor="bg-white"
                textColor="text-black"
                iconBgColor="bg-white"
                emojiRounded=""
              >
                <>
                  가정의 달, <span className="text-[#F54951]">가정의 힘</span>
                  으로 집에서 시작되는 <br className="block" /> 진짜 제대로 된
                  교육이 필요하다면?
                </>
              </EmojiChildrenLeftBox>
              <EmojiChildrenRightBox
                icon={icon2}
                text="가정의 힘이 가득 필요한 지금! 모든 엄마 선생님들을 응원하며 준비했어요!"
                margin="18%"
                bgColor="bg-white"
                textColor="text-black"
                iconBgColor="bg-white"
                align="right"
                emojiRounded=""
              >
                <>
                  가정의 힘이 가득 필요한 지금!
                  <br className="block" />
                  모든 <span className="text-[#F54951]">엄마 선생님</span>들을
                  응원하며 준비했어요!
                </>
              </EmojiChildrenRightBox>
              <EmojiChildrenLeftBox
                icon={icon3}
                text="5월엔, 다른 걱정 없이 아이와 함께
              집에서 신앙과 영어를 바로잡으세요!"
                margin="18%"
                bgColor="bg-white"
                textColor="text-black"
                iconBgColor="bg-white"
                emojiRounded=""
              >
                <>
                  5월엔, 다른 걱정 없이 아이와 함께
                  <br className="block" /> 집에서
                  <span className="text-[#F54951]"> 신앙과 영어</span>를
                  바로잡으세요!
                </>
              </EmojiChildrenLeftBox>
            </section>

            {/* <section className="flex flex-col items-center justify-center gap-3 text-lg font-bold sm:gap-5">
              <EmojiChildrenBox
                icon={icon1}
                text="가정의 달, 가정의 힘으로 집에서 시작되는 진짜 제대로 된 교육이 필요하다면?"
                margin="18%"
                bgColor="bg-white"
                textColor="text-black"
                iconBgColor="bg-white"
                emojiRounded=""
              >
                <>
                  가정의 달, <span className="text-[#F54951]">가정의 힘</span>
                  으로 집에서 시작되는
                  <br className="hidden sm:block" /> 진짜 제대로 된 교육이
                  필요하다면?
                </>
              </EmojiChildrenBox>
              <EmojiChildrenBox
                icon={icon2}
                text="가정의 힘이 가득 필요한 지금! 모든 엄마 선생님들을 응원하며 준비했어요!"
                margin="18%"
                bgColor="bg-white"
                textColor="text-black"
                iconBgColor="bg-white"
                align="right"
                emojiRounded=""
              >
                <>
                  가정의 힘이 가득 필요한 지금!
                  <br className="block" />
                  모든 <span className="text-[#F54951]">엄마 선생님</span>들을
                  응원하며 준비했어요!
                </>
              </EmojiChildrenBox>
              <EmojiChildrenBox
                icon={icon3}
                text="5월엔, 다른 걱정 없이 아이와 함께
              집에서 신앙과 영어를 바로잡으세요!"
                margin="18%"
                bgColor="bg-white"
                textColor="text-black"
                iconBgColor="bg-white"
                emojiRounded=""
              >
                <>
                  5월엔, 다른 걱정 없이 아이와 함께
                  <br className="hidden sm:block" /> 집에서
                  <span className="text-[#F54951]"> 신앙과 영어</span>를
                  바로잡으세요!
                </>
              </EmojiChildrenBox>
            </section> */}
          </div>

          {/* 설명회 섹션 */}
          <div className="flex flex-col gap-5">
            {/* 타이틀 */}
            <section className="flex flex-col gap-3 text-center">
              <div className="text-xl font-bold sm:text-3xl">
                든든한 가정을 위해 알차게 준비한
              </div>
              <div className="m-auto flex max-w-[250px] flex-col sm:max-w-[350px]">
                <img src={Online_Title} alt="5월 온라인 설명회" />
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full max-w-[480px]">
              <img src={Online_Video} alt="conference_thumbnail" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-[#F54951]"
              hoverBgColor="hover:bg-[#F54951]/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                무료 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="relative flex items-center justify-center overflow-hidden bg-[#FC8E93]">
        {/* 1. 배경 컨테이너 레이어 */}
        <div className="absolute inset-0">
          <img
            src={balloon1}
            alt="balloon1"
            className="absolute left-[3%] top-36 max-w-[60px] select-none sm:left-[5%] sm:top-40 sm:max-w-[80px] md:left-[10%] md:top-48 md:max-w-[80px]"
          />
          <img
            src={balloon2}
            alt="balloon2"
            className="absolute right-[3%] top-36 max-w-[68px] select-none sm:right-[5%] sm:top-40 sm:max-w-[100px] md:right-[10%] md:top-36 md:max-w-[120px]"
          />
        </div>

        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="relative m-auto flex max-w-[720px] flex-col items-center gap-10 px-5 py-20 sm:gap-14">
          <section className="relative flex flex-col gap-3 sm:gap-5">
            {/* 타이틀 */}
            <div className="text-center text-2xl font-extrabold text-black sm:text-4xl">
              우리 아이, 혹시 예수님의 부활을
              <br />
              영어로 설명할 수 있나요?
            </div>
            <div className="text-center text-lg font-medium text-black sm:text-2xl">
              🙋‍♀️ 아이에게 아래 영어 말씀을 읽고
              <br />
              말하고 암송하게 해주세요!
            </div>
          </section>

          <section className="relative flex flex-col gap-5 bg-white p-5 sm:max-w-[400px]">
            {/* 배경 이미지 */}
            <div className="absolute inset-0">
              <img
                src={risen1}
                alt="risen1"
                className="absolute -left-5 -top-8 w-20 sm:-left-10 sm:-top-12 sm:w-28"
              />
              <img
                src={risen2}
                alt="risen2"
                className="absolute -bottom-8 -right-5 w-20 sm:-bottom-12 sm:-right-10 sm:w-28"
              />
            </div>
            {/* 실제 컨텐츠 */}
            <div className="relative text-center text-sm font-normal text-black sm:text-lg">
              On the evening of the day, /<br />
              the disciples were together.
              <br />
              They had locked the doors /<br />
              because they were afraid of the Jews.
              <br />
              <span className="font-bold">Jesus </span>
              came in / and stood among them. <br />
              He said, /{' '}
              <span className="font-bold">“May peace be with you!”</span> <br />
              He showed them his hands / and his side. <br />
              The disciples were very happy.
            </div>
            <div className="text-center text-[10px] font-normal text-black sm:text-sm">
              실제 젭스 초등 고학년 학생이 암송하는
              <br />[ English Story Bible ] 47권 내용
            </div>
          </section>

          <section className="flex flex-col gap-3 sm:gap-5">
            {/* 타이틀 */}
            <div className="text-center text-xl font-extrabold text-black sm:text-4xl">
              아이가 영어 말씀을 어려워 한다면?
              <br />
              지금, 젭스홈스쿨이 필요한 때!
            </div>
            <div className="text-center text-lg font-medium leading-snug text-black sm:text-2xl">
              젭스홈스쿨에선 아이들이 <br className="block sm:hidden" />
              성경의 모든 사건들을
              <br /> 영어로 술술~ 암송하게 됩니다!
            </div>
          </section>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="relative flex items-center justify-center bg-[#FFEDE7]">
        {/* 1. 배경 컨테이너 레이어 */}
        <div className="absolute inset-0">
          <img
            src={balloon4}
            alt="balloon4"
            className="absolute -top-8 left-[7%] w-20 sm:-top-6 sm:left-24 sm:w-28"
          />
          <img
            src={balloon3}
            alt="balloon3"
            className="absolute -top-16 right-[7%] w-14 sm:-top-20 sm:right-24 sm:w-20"
          />
        </div>

        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="relative flex max-w-[720px] flex-col gap-10 px-5 py-20 sm:gap-16">
          {/* 박스 */}
          <section className="flex w-full flex-col gap-5 sm:gap-8">
            <TextBox>
              <div className="m-0 font-bold text-black">
                집에서 엄마와 함께하는 홈스쿨로
                <br />
                <span className="text-[#FA5735]">
                  영어와 신앙을 바로 세우는 우리 가정!
                </span>
                <br />
              </div>
            </TextBox>
            <TextBox>
              <div className="font-bold text-black">
                정철 교수법&성경 말씀 기반의 교재로
                <br />
                <span className="text-[#35A7FA]">
                  우리 가정 영어&신앙 올인원 케어!
                </span>
              </div>
            </TextBox>
            <TextBox>
              <div className="m-0 font-bold text-black">
                가정의 달 맞이 '가정의 힘'을 위해 선물하는
                <br />
                <span className="text-[#FF9B00]">
                  선착순 50명 홈스쿨 등록 파격 할인!
                </span>
              </div>
            </TextBox>
          </section>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
              가정의 달 홈스쿨 혜택 받기
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

const DoubleLineButton = ({
  children,
  onClick,
  borderColor = 'border-[#2b492a]',
  bgColor = 'bg-black',
  hoverBgColor = 'hover:bg-black/50',
  textColor = 'text-white',
}: {
  children: ReactNode;
  onClick: () => void;
  borderColor?: string;
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
}) => {
  return (
    <div
      className={`cursor-pointer rounded-[24px] border-[2px] ${borderColor} p-1 sm:rounded-[41px] sm:border-[3px] sm:p-[7px]`}
      style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
      onClick={onClick}
    >
      <div
        className={`rounded-[17px] ${bgColor} text-center ${textColor} ${hoverBgColor} sm:rounded-[30px]`}
      >
        {children}
      </div>
    </div>
  );
};

const DoubleLineWithCursorButton = ({
  children,
  onClick,
  borderColor = 'border-white/70',
  bgColor = 'bg-[#ffb218]',
  hoverBgColor = 'hover:bg-[#e6a016]',
  textColor = 'text-black',
}: {
  children: ReactNode;
  onClick: () => void;
  borderColor?: string;
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
}) => (
  <div
    className={`relative cursor-pointer rounded-[24px] border-[2px] ${borderColor} p-1 sm:rounded-[41px] sm:border-[3px] sm:p-[7px]`}
    style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
    onClick={onClick}
  >
    <div
      className={`rounded-[17px] border-4 border-white ${bgColor} text-center ${textColor} ${hoverBgColor} sm:rounded-[30px]`} // hover : #ffb218의 90%
    >
      {children}
    </div>
    <div className="absolute right-[5%] top-[65%] h-10 w-10 sm:h-14 sm:w-14">
      <img src={cursor} alt="cursor" className="h-10 w-10 sm:h-14 sm:w-14" />
    </div>
  </div>
);

const TextBox = ({ children }: { children: ReactNode }) => {
  return (
    <div
      className="w-full rounded-3xl bg-white px-7 py-5 text-center text-base font-bold sm:rounded-[40px] sm:px-10 sm:py-7 sm:text-2xl"
      style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
    >
      {children}
    </div>
  );
};

export default HomeschoolEvent_25_5;
